export default "__VITE_ASSET__90aadf38__"